<template>
  <div class="container">
    <!-- 头部导航 -->
    <div class="header cont">
      <div class="imgbox">
        <img src="../../../assets/website/logo.png" />
      </div>
      <ul class="nav">
        <li @click="goAnchor('#ancho1')">首页</li>
        <li @click="goAnchor('#ancho2')">服务支持</li>
        <li @click="goAnchor('#ancho3')">货源车源</li>
        <li @click="goAnchor('#ancho4')">产品介绍</li>
        <li @click="goAnchor('#ancho5')">关于我们</li>
        <li @click="goAnchor('#ancho6')">业务范围</li>
        <li @click="goAnchor('#ancho7')">合作伙伴</li>
      </ul>
       <div class="logoImg">
      <div v-if="loginNameFlag">
        <el-button type="primary" v-if="loginFlag" @click="registerGo">注册</el-button>
        <el-button type="primary" v-if="loginFlag" @click="loginGo">登录</el-button>
      </div>
      <div v-if="!loginNameFlag">
        <el-dropdown class="my-dropdown">
          <!-- 头像 用户名称 -->
          <div @click="tzxtFn" style="cursor: pointer;">
            <img class="avatar" src="../../../assets/images/loginer.png" alt />
          <span class="username">{{this.nameCode}}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <!--  slot="dropdown" 插槽 -->
          <!-- <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-unlock" @click.native="logout()">退出登录</el-dropdown-item>
          </el-dropdown-menu> -->
        </el-dropdown>
      </div>
    </div>
    </div>

    <!-- 头部图片 -->
    <div class="img_main">
      <img src="../../../assets/website/banner.png" alt />
    </div>
    <!-- 主体 -->
    <div class="main cont">
      <!-- 主体-翻页数字 -->
      <!-- <div>
        <el-card>
          <div class="main_number">
            <div class="number">
              <div class="chartNum">
                <div class="box-item">
                  <li
                    :class="{'number-item': !isNaN(item), 'mark-item': isNaN(item) }"
                    v-for="(item,index) in orderNum"
                    :key="index"
                  >
                    <span v-if="!isNaN(item)">
                      <i ref="numberItem">0123456789</i>
                    </span>
                    <span class="comma" v-else>{{item}}</span>
                  </li>
                </div>
                <p>平台累计发货量</p>
              </div>
            </div>
            <div class="number">222</div>
            <div class="number">333</div>
            <div class="number">1444411</div>
          </div>
        </el-card>
      </div>-->
      <!-- 主体-服务支持 -->
      <div class="main_fuWu">
        <div class="fuwu_title">
          <div class="h3" id="ancho2">服务支持</div>
          <div class="span"></div>
        </div>
        <el-carousel height="440px">
          <el-carousel-item v-for="(item,index) in 4" :key="index">
            <ul>
              <li>
                <div>
                  <div class="div">
                    <img src="../../../assets/website/海量货源.png" alt />
                  </div>
                  <span>海量货源</span>
                  <p>
                    平台与各大钢铁企业、各大钢铁物流园建立了长期合作，货源充足。
                    货物包括热轧商品卷、冷轧商品卷、电工钢、中厚板和长材等产品。
                  </p>
                </div>
              </li>
              <li>
                <div>
                  <div class="div">
                    <img src="../../../assets/website/海量车源.png" alt />
                  </div>
                  <span>海量车源</span>
                  <p>
                    平台注册专业运输大宗钢铁产品车辆1500多辆，专业运输车队20余家。
                    平台注册车辆和驾驶员都经过资质审查，保证提供运输服务的车辆具备合法有效的营运证，驾驶员具有合法有效的从业资格证。
                  </p>
                </div>
              </li>
              <li>
                <div>
                  <div class="div">
                    <img src="../../../assets/website/车辆监控.png" alt />
                  </div>
                  <span>车辆监控</span>

                  <p>
                    平台对运输、交易全过程进行实时监控和动态管理。
                    平台对运输地点、轨迹、状态进行动态监控。对装货、卸货、结算等进行有效管控的功能和物流信息全流程跟踪、记录。
                  </p>
                </div>
              </li>
            </ul>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 主体-货源 -->
      <div class="main_huoYuan">
        <div class="fuwu_title">
          <div class="h3" id="ancho3">货源车源</div>
          <div class="span"></div>
        </div>
        <div class="huoYuan">
          <div class="huoyuan_img">
            <img src="../../../assets/website/货源车源左侧.png" alt />
          </div>
          <div class="huoyuan_table">
            <table width="100%" class="table">
              <tr>
                <td><span class="icon">起</span>河北省唐山市曹妃甸区</td>
                <td><span class="icon" style="background: #fc5657;">终</span>山西省长治市襄垣县</td>
                <td>热卷</td>
                <td>32.4343吨</td>
                <td>￥ 3429.56</td>
              </tr>
              <tr>
                <td><span class="icon">起</span>山东省济南市历下区</td>
                <td><span class="icon" style="background: #fc5657;">终</span>河北省唐山市曹妃甸区</td>
                <td>冷卷</td>
                <td>32.4343吨</td>
                <td>￥ 3421.44</td>
              </tr>
              <tr>
                <td><span class="icon">起</span>北京市市辖区西城区</td>
                <td><span class="icon" style="background: #fc5657;">终</span>河北省唐山市曹妃甸区</td>
                <td>中厚板</td>
                <td>30.1523吨</td>
                <td>￥ 3021.12</td>
              </tr>
              <tr>
                <td><span class="icon">起</span>山东省日照市</td>
                <td><span class="icon" style="background: #fc5657;">终</span>山西省运城市临猗县</td>
                <td>热卷</td>
                <td>29.434吨</td>
                <td>￥ 2426.00</td>
              </tr>
              <tr>
                <td><span class="icon">起</span>天津市市辖区东丽区</td>
                <td><span class="icon" style="background: #fc5657;">终</span>河北省唐山市曹妃甸区</td>
                <td>冷卷</td>
                <td>25.303吨</td>
                <td>￥ 1256.66</td>
              </tr>
              <tr>
                <td><span class="icon">起</span>河北省唐山市曹妃甸区</td>
                <td><span class="icon" style="background: #fc5657;">终</span>北京市市辖区朝阳区</td>
                <td>冷卷</td>
                <td>32.434吨</td>
                <td>￥ 2521.56</td>
              </tr>
            </table>
            <el-button
              type="primary"
              style="float:right;margin-top:10px;margin-bottom:10px;"
              @click="go"
            >我要承运</el-button>

            <table width="100%" class="table">
              <tr>
                <td><i class="fa fa-circle fa-lg" aria-hidden="true"></i>【唐山市-山西省长治】</td>
                <td>红头挂车</td>
                <td>16*3*3(米)</td>
                <td>12轴</td>
                <td>张师傅</td>
                <td>186****7850</td>
              </tr>
              <tr>
                <td><i class="fa fa-circle fa-lg" aria-hidden="true"></i>【天津市东丽区-曹妃甸区】</td>
                <td>白头挂车</td>
                <td>16*5*3(米)</td>
                <td>8轴</td>
                <td>李师傅</td>
                <td>135****6725</td>
              </tr>
              <tr>
               <td><i class="fa fa-circle fa-lg" aria-hidden="true"></i>【唐山市-天津市东丽区】</td>
                <td>红头挂车</td>
                <td>16*3*3(米)</td>
                <td>12轴</td>
                <td>王师傅</td>
                <td>188****3778</td>
              </tr>
              <tr>
                <td><i class="fa fa-circle fa-lg" aria-hidden="true"></i>【河北省沧州市--曹妃甸区】</td>
                <td>红头挂车</td>
                <td>16*3*3(米)</td>
                <td>12轴</td>
                <td>贾师傅</td>
                <td>150****0572</td>
              </tr>
              <tr>
                <td><i class="fa fa-circle fa-lg" aria-hidden="true"></i>【唐山市-天津市河北区】</td>
                <td>白头挂车</td>
                <td>8*8*3(米)</td>
                <td>2轴</td>
                <td>冯师傅</td>
                <td>138****9875</td>
              </tr>
            </table>
            <el-button type="primary"  style="float:right;margin-top:10px;margin-bottom:10px;" @click="go">我要找车</el-button>
          </div>
        </div>
      </div>
      <!-- 主体-产品 -->
      <div class="main_chanPing">
        <div class="fuwu_title">
          <div class="h3" id="ancho4">产品介绍</div>
          <div class="span"></div>
        </div>
        <div class="chanping">
          <div class="chanping_data">
            <ul>
              <li @mouseover="huoZhuBtn($event)" @mouseout="removehzBtn($event)">
                <div class="span">
                  <img src="../../../assets/website/司机端app图标.png" alt />
                </div>
                <div class="div">
                  <div>货主端</div>
                  <p>针对货主提供了发布货源、查看订单、监控运单、流程审批、地址维护等功能；为客户从发布货源到货物签收，从结算到开票提供管家式服务；</p>
                </div>
              </li>
              <li @mouseover="siJIBtn($event)" @mouseout="removesjBtn($event)">
                <div class="span">
                  <img src="../../../assets/website/司机端app图标.png" alt />
                </div>

                <div class="div">
                  <div>司机端</div>
                  <p>提供海量优质货源，解决司机找货难的问题，提供结算进度查询功能，司机可随时查询结算进度，另外提供了接单、抢单功能，做到装车、运输、卸货全流程跟踪监控；</p>
                </div>
              </li>
              <li>
                <div class="span">
                  <img src="../../../assets/website/平台端图标.png" alt />
                </div>

                <div class="div">
                  <div>平台端</div>
                  <p>作为托运人与承运人之间的桥梁枢纽，平台端承载了资质审核、订单管理、投诉受理、财务管理、平台资源、系统管理等功能；</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="chanping_img">
            <!-- <el-carousel :interval="5000" height="700px" arrow="always">
              <el-carousel-item> </el-carousel-item>
            </el-carousel>-->
            <img
              v-show="huoZhuFlag"
              src="../../../assets/website/5ec9dfc845af5da21c7d676eebbb10d.png"
              alt
            />

            <img v-show="siJiFlag" src="../../../assets/website/1.png" alt />
          </div>
        </div>
      </div>
      <!-- 主体-我们 -->
      <div class="main_women">
        <div class="fuwu_title">
          <div class="h3" id="ancho5">关于我们</div>
          <div class="span"></div>
        </div>
        <div class="women">
          <div class="women_img">
            <img src="../../../assets/website/关于我们左侧.png" alt />
          </div>
          <div class="women_data">
            <ul>
              <li>
                <div class="div">
                  <div>企业简介</div>
                  <p>
                    中物现代（洋浦）物流科技有限公司采用“互联网+物流”，致力于为客户提供智能物流服务，助力企业向信息化、现代化、智能化转型升级。用科技为用户提供线上、线下立体化一站式物流服务。为企业注入新的活力 ，带你迈进智慧互联的物流新时代。
                    每一次创新不仅源于对市场趋势的不懈探索，更有着我们对物流行业长期的实践。公司与合作伙伴一起搭建了辐射全国的物流网络。凭借科技实力、专业实力、以及良好的服务水平，赢得了客户的信赖。用科技驱动商业革新，让企业运营变得更智慧。通过不断自主创新和技术研发，与合作伙伴携手走向物流新时代。
                  </p>
                </div>
              </li>
              <li>
                <div class="div">
                  <div>企业文化</div>
                  <p>中物现代正以前瞻的姿态，打造“诚信、协同、开放、共享”的智慧物流生态圈，助力企业实现物流信息化、智慧化发展，共同创造一个万物互联的智慧世界。</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 主体-地图 -->
      <div class="main_map">
        <div class="fuwu_title">
          <div class="h3" id="ancho6">业务范围</div>
          <div class="span"></div>
        </div>
        <!-- <div class="map_title">
          <ul>
            <li>
              <div>1111</div>
              <div>合作企业</div>
            </li>
            <li>222</li>
            <li>333</li>
          </ul>
        </div>-->
        <div class="map">
          <div id="map"></div>
        </div>
      </div>
      <!-- 主体-合作 -->
      <div class="main_hezuo">
        <div class="fuwu_title">
          <div class="h3" id="ancho7">合作伙伴</div>
          <div class="span"></div>
        </div>
        <div>
          <el-carousel height="200px">
            <el-carousel-item v-for="(item,index) in imgData" :key="index">
              <ul>
                <li>
                  <img :src="item.img1" alt />
                </li>
                <li>
                  <img :src="item.img2" alt />
                </li>
                <li>
                  <img :src="item.img3" alt />
                </li>
                <li>
                  <img :src="item.img4" alt />
                </li>
              </ul>
              <!-- <div>
                <ul>
                  <li>
                    <img src="../../../assets/website/兴民钢圈.png" alt />
                  </li>
                  <li>
                    <img src="../../../assets/website/兴民钢圈.png" alt />
                  </li>
                  <li>
                    <img src="../../../assets/website/二十二冶金.png" alt />
                  </li>
                  <li>
                    <img src="../../../assets/website/包钢钢铁.png" alt />
                  </li>
                </ul>
              </div>-->
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="foot">
      <div class="cont foot_main">
        <div class="img com">
          <img src="../../../assets/website/logo.png" alt />
        </div>
        <div class="data">
          <ul>
            <li @click="goAnchor('#ancho2')">服务支持</li>
            <li @click="goAnchor('#ancho3')">货源车源</li>
            <li @click="goAnchor('#ancho4')">产品介绍</li>
            <li @click="goAnchor('#ancho5')">关于我们</li>
            <li @click="goAnchor('#ancho6')">业务范围</li>
            <li @click="goAnchor('#ancho7')">合作伙伴</li>
          </ul>
          <ul>
            <li class="minfont">企业地址：海南省洋浦经济开发区新英湾区保税港区2号办公楼A064室</li>
            <li class="minfont" style="margin-left:20px">企业邮箱：sales@zw56.com.cn</li>
          </ul>
        </div>
        <div class="number com">
          <h1 style="margin:0">010-5969-3540</h1>
          <p class="minfont">24小时服务热线</p>
        </div>
      </div>
    </div>
    <div class="footer">中物现代（洋浦）物流科技有限公司  琼ICP备20002989号</div>
    <div class="furx">
      <div class="iconBox">
        <i class="fa fa-phone fa-2x" aria-hidden="true"></i><span>服务热线</span>
        <div class="phone">{{phone}}</div>
        </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import { findDictByCode } from '@/api/soc-customer'
export default {
  data () {
    return {
      phone: '',
      nameCode: '',
      loginNameFlag: true,
      loginFlag: true,
      huoZhuFlag: true,
      siJiFlag: false,
      orderNum: ['0', '0', '0', '0', '0', '0', '0', '0'], // 默认订单总数
      imgData: [
        {
          img1: require('../../../assets/website/瑞丰钢铁.png'),
          img2: require('../../../assets/website/包钢钢铁.png'),
          img3: require('../../../assets/website/陆港钢铁.png'),
          img4: require('../../../assets/website/首钢logo.png')
        },
        {
          img1: require('../../../assets/website/二十二冶金.png'),
          img2: require('../../../assets/website/海尔.png'),
          img3: require('../../../assets/website/唐钢中厚板.png'),
          img4: require('../../../assets/website/兴民钢圈.png')
        },
        {
          img1: require('../../../assets/website/瑞丰钢铁.png'),
          img2: require('../../../assets/website/包钢钢铁.png'),
          img3: require('../../../assets/website/陆港钢铁.png'),
          img4: require('../../../assets/website/首钢logo.png')
        }
        // {
        //   img1: '../../../assets/website/瑞丰钢铁.png',
        //   img2: '../../../assets/website/瑞丰钢铁.png',
        //   img3: '../../../assets/website/瑞丰钢铁.png',
        //   img4: '../../../assets/website/瑞丰钢铁.png'
        // },
      ],
      dataTable: [
        {
          form: '河北省唐山市曹妃甸区',
          to: '河北省唐山市曹妃甸区',
          three: '冷卷',
          four: '32.3599吨',
          fivefour: '￥ 22434.43'
        },
        {
          form: '河北省唐山市曹妃甸区',
          to: '河北省唐山市曹妃甸区',
          three: '冷卷',
          four: '32.3599吨',
          fivefour: '￥ 22434.43'
        },
        {
          form: '河北省唐山市曹妃甸区',
          to: '河北省唐山市曹妃甸区',
          three: '冷卷',
          four: '32.3599吨',
          fivefour: '￥ 22434.43'
        },
        {
          form: '河北省唐山市曹妃甸区',
          to: '河北省唐山市曹妃甸区',
          three: '冷卷',
          four: '32.3599吨',
          fivefour: '￥ 22434.43'
        },
        {
          form: '河北省唐山市曹妃甸区',
          to: '河北省唐山市曹妃甸区',
          three: '冷卷',
          four: '32.3599吨',
          fivefour: '￥ 22434.43'
        }
      ]
    }
  },
  mounted () {
    findDictByCode({ code: 'p_phone' }).then(res => {
      this.phone = res[0].value
    })
    document.title = '首页'
    let myChart = this.$echarts.init(document.getElementById('map'))

    var chinaGeoCoordMap = {
      黑龙江: [127.9688, 45.368],
      内蒙古: [110.3467, 41.4899],
      吉林: [125.8154, 44.2584],
      北京市: [116.4551, 40.2539],
      辽宁: [123.1238, 42.1216],
      河北: [114.4995, 38.1006],
      天津: [117.4219, 39.4189],
      山西: [112.3352, 37.9413],
      陕西: [109.1162, 34.2004],
      甘肃: [103.5901, 36.3043],
      宁夏: [106.3586, 38.1775],
      青海: [101.4038, 36.8207],
      新疆: [87.9236, 43.5883],
      西藏: [91.11, 29.97],
      四川: [103.9526, 30.7617],
      重庆: [108.384366, 30.439702],
      山东: [117.1582, 36.8701],
      河南: [113.4668, 34.6234],
      江苏: [118.8062, 31.9208],
      安徽: [117.29, 32.0581],
      湖北: [114.3896, 30.6628],
      浙江: [119.5313, 29.8773],
      福建: [119.4543, 25.9222],
      江西: [116.0046, 28.6633],
      湖南: [113.0823, 28.2568],
      贵州: [106.6992, 26.7682],
      云南: [102.9199, 25.4663],
      广东: [113.12244, 23.009505],
      广西: [108.479, 23.1152],
      海南: [110.3893, 19.8516],
      上海: [121.4648, 31.2891]
    }
    var chinaDatas = [
      [
        {
          name: '黑龙江',
          value: 0,
          price: 100,
          num: 2
        }
      ],
      [
        {
          name: '内蒙古',
          value: 0,
          price: 100,
          num: 2
        }
      ],
      [
        {
          name: '吉林',
          value: 0,
          price: 100,
          num: 2
        }
      ],

      [
        {
          name: '河北',
          value: 0,
          price: 100,
          num: 2
        }
      ],

      [
        {
          name: '山西',
          value: 0,
          price: 100,
          num: 2
        }
      ],
      [
        {
          name: '陕西',
          value: 0,
          price: 100,
          num: 2
        }
      ],
      [
        {
          name: '甘肃',
          value: 0,
          price: 100,
          num: 2
        }
      ],

      [
        {
          name: '青海',
          value: 0,
          price: 100,
          num: 2
        }
      ],
      [
        {
          name: '新疆',
          value: 0,
          price: 100,
          num: 2
        }
      ],

      [
        {
          name: '江苏',
          value: 0,
          price: 100,
          num: 2
        }
      ],
      [
        {
          name: '安徽',
          value: 0,
          price: 100,
          num: 2
        }
      ],

      [
        {
          name: '江西',
          value: 0,
          price: 100,
          num: 2
        }
      ],

      [
        {
          name: '贵州',
          value: 0,
          price: 100,
          num: 2
        }
      ],

      [
        {
          name: '海南',
          value: 0,
          price: 100,
          num: 2
        }
      ]
    ]
    var convertData = function (data) {
      var res = []
      for (var i = 0; i < data.length; i++) {
        var dataItem = data[i]
        // 			console.log('dataItem',dataItem) //第二个数据
        var fromCoord = [116.4551, 40.2539]
        var toCoord = chinaGeoCoordMap[dataItem[0].name]
        // 			console.log('toCoord',toCoord);//第一个地址
        if (fromCoord && toCoord) {
          res.push([
            {
              coord: fromCoord,
              value: dataItem[0].value
            },
            {
              coord: toCoord,
              dataItem: dataItem
            }
          ])
        }
      }
      return res
    }
    let redName = '新疆'
    var planePath =
      'path://M.6,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705'

    var series = [];
    [['北京市', chinaDatas]].forEach(function (item, i) {
      // console.log('得到数据',item)
      series.push(
        {
          type: 'lines',
          zlevel: 2,
          effect: {
            // 括 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
            show: true,
            period: 4, // 箭头指向速度，值越小速度越快
            trailLength: 0.3, // 特效尾迹长度[0,1]值越大，尾迹越长重
            symbol: 'circle', // 箭头图标
            symbolSize: 3, // 图标大小
            color: '#FC6E6E'
          },

          // symbol: ['none', 'arrow'],
          lineStyle: {
            normal: {
              // shadowBlur: .5,
              // // shadowColor: 'rgba(221, 244, 253, 1)',
              // shadowColor: 'rgba(221, 244, 253, 1)',
              // // shadowOffsetX: -5,
              // shadowOffsetY: 5,

              width: 0.7, // 尾迹线条宽度
              opacity: 0.5, // 尾迹线条透明度
              curveness: 0.2, // 尾迹线条曲直度
              color: function (params) {
                // 圆环显示文字
                // console.log('redName',redName)

                return '#0c46a2'
              }
            },
            color: 'red'
          },
          tooltip: {
            //  show:false,
            trigger: 'item',
            backgroundColor: 'rgba(8, 18, 42, 0.85)',
            borderColor: '#0c46a2',
            showDelay: 0,
            hideDelay: 0,
            enterable: true,
            transitionDuration: 0,
            extraCssText: 'z-index:100',
            formatter: function (params, ticket, callback) {
              // 根据业务自己拓展要显示的内容
              // console.log('params--1',params)
              let res = ''
              let name = params.data.dataItem[0].name
              let price = params.data.dataItem[0].price
              let num = params.data.dataItem[0].num
              // res = "<div style='color:#fff;'><span>北京->" + name + "</span><br/><span>均价：" + price + "</span><br/><span>线路数：" + num + "</span></div>";
              res = "<div style='color:#fff;'><span>北京->" + name + '</span>'

              let html =
                '<div class="mapTableContent"><div class="tableTop">北京 -> 新疆</div>'
              if (name == redName) {
                return html
              } else {
                return res
              }
            }
          },
          data: convertData(item[1])
        },
        {
          type: 'effectScatter',
          coordinateSystem: 'geo',
          zlevel: 2,
          rippleEffect: {
            // 涟漪特效
            period: 4, // 动画时间，值越小速度越快
            brushType: 'fill', // 波纹绘制方式 stroke, fill
            scale: 2.2 // 波纹圆环最大限制，值越大波纹越大
          },

          // 括 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
          // symbol: 'none',
          symbol: 'circle',
          symbolSize: function (val) {
            return 5 // 圆环大小
          },
          itemStyle: {
            normal: {
              show: false,
              // color: '#f00'
              color: function (params) {
                // 圆环显示文字
                // console.log('redName',redName)

                return '#0c46a2'
              },
              borderWidth: 0,
              shadowColor: '#b5e8fa', // 发光🉐效果
              shadowBlur: 4
            }
          },
          tooltip: {
            //  show:false,
            trigger: 'item',
            backgroundColor: 'rgba(8, 18, 42, 0.85)',
            borderColor: '#040616',
            showDelay: 0,
            hideDelay: 0,
            enterable: true,
            transitionDuration: 0,
            extraCssText: 'z-index:100',
            formatter: function (params, ticket, callback) {
              // 根据业务自己拓展要显示的内容
              // console.log('params--2',params)
              let res = ''
              let name = params.data.dataItem[0].name
              let price = params.data.dataItem[0].price
              let num = params.data.dataItem[0].num
              res =
                "<div style='color:#fff;padding:10px;'><span>北京->" +
                name +
                '</span><br/><span>均价：' +
                price +
                '</span><br/><span>线路数：' +
                num +
                '</span></div>'
              return res
            }
          },
          data: item[1].map(function (dataItem) {
            // 	console.log('dataItem',dataItem[0]);
            return {
              dataItem: dataItem,
              name: dataItem[0].name,
              value: chinaGeoCoordMap[dataItem[0].name].concat([
                dataItem[0].value
              ])
            }
          })
        },
        // 被攻击点
        {
          type: 'scatter',
          coordinateSystem: 'geo',
          zlevel: 1,
          rippleEffect: {
            period: 4,
            brushType: 'stroke',
            scale: 4
          },

          symbol: 'circle',
          color: 'rgba(128, 220, 251, .6)',
          symbolSize: 20,
          data: [
            {
              name: item[0],
              value: chinaGeoCoordMap[item[0]].concat([10])
            }
          ]
        }
      )
    })

    let option = {
      tooltip: {
        //  show:false,
        trigger: 'item',
        backgroundColor: 'rgba(166, 200, 76, 0.82)',
        borderColor: '#fff',
        showDelay: 0,
        hideDelay: 0,
        enterable: true,
        transitionDuration: 0,
        extraCssText: 'z-index:100'
      },
      // backgroundColor: "#001339",
      backgroundColor: '#fff',
      // visualMap: { //图例值控制
      //     min: 0,
      //     max: 1,
      //     calculable: true,
      //     show: false,
      //     color: ['#4fc6ef', '#4fc6ef', '#4fc6ef', '#4fc6ef', '#4fc6ef'],
      //     textStyle: {
      //         color: '#fff'
      //     }
      // },
      geo: {
        map: 'china',
        zoom: 1,
        label: {
          emphasis: {
            show: false
          }
        },
        roam: false, // 是否允许缩放
        itemStyle: {
          normal: {
            color: '#F4F4F4', // 地图背景色
            borderColor: '#6481a0', // 省市边界线00fcff 516a89
            borderWidth: 1
          },
          emphasis: {
            color: 'rgba(37, 43, 61, .5)' // 悬浮背景
          }
          //   normal: {
          //     areaColor: '#132937',
          //     borderColor: '#0692a4'
          // },
          // emphasis: {
          //     areaColor: '#0b1c2d'
          // }
        }
      },
      series: series
    }
    myChart.setOption(option)
  },
  methods: {
    setting () {
      this.changePawDialog = true
    },
    tzxtFn () {
      this.$router.push(store.getIp())
    },
    // 退出登录
    logout () {
      this.$axios
        .get(this.global.commonName + '/oauth/remove/token')
        .then((res) => {
          store.delUser()
          localStorage.clear()
          sessionStorage.clear()
          this.$router.push('/login')
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    },
    loginGo () {
      this.$router.push({ name: 'login' })
    },
    // 注册
    registerGo () {
      this.$router.push('/common/register')
    },
    huoZhuBtn () {
      this.huoZhuFlag = true
      this.siJiFlag = false
    },
    removehzBtn () {
      // this.huoZhuFlag = false
      // this.siJiFlag = true
    },
    siJIBtn () {
      this.huoZhuFlag = false
      this.siJiFlag = true
    },
    removesjBtn () {
      // this.huoZhuFlag = true
      // this.siJiFlag = false
    },
    // 按钮-跳转登录页
    go () {
      this.$router.push({
        path: '/login'
      })
    },
    goAnchor (selector) {
      let anchor = this.$el.querySelector(selector)
      // document.documentElement.scrollTop = anchor.offsetTop;
      let total = anchor.offsetTop

      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      // 获取当前滚动条与窗体顶部的距离
      let distance =
        document.documentElement.scrollTop || document.body.scrollTop
      // 计算每一小段的距离
      let step = total / 50;
      (function smoothDown () {
        if (distance < total) {
          distance += step
          // 移动一小段
          document.body.scrollTop = distance
          document.documentElement.scrollTop = distance
          // 设定每一次跳动的时间间隔为10ms
          setTimeout(smoothDown, 10)
        } else {
          // 限制滚动停止时的距离
          document.body.scrollTop = total + 630
          document.documentElement.scrollTop = total + 630
        }
      })()
    }
  },
  created () {
    this.nameCode = localStorage.getItem('userName')
    if (this.nameCode == '' || this.nameCode == null) {
      this.loginNameFlag = true
    } else {
      this.loginNameFlag = false
    }
  }
}
</script>

<style scoped lang="less">
.furx{
  position: fixed;
  right: 0;
  bottom: 200px;
  background: #02284a;
  color:#fff;
  width: 70px;
  height: 70px;
  display: flex;
  flex-direction:column;
  .iconBox{
    position: relative;
    display: flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;
    height: 100%;
    span{
      font-size: 14px;
    }
  }
  .phone{
    position: absolute;
    left: -130px;
    top: 0;
    width: 130px;
    height: 70px;
    background: #001121;
    display: none;
    text-align: center;
    line-height: 70px;
  }
  .iconBox:hover .phone{
    display: block;
  }
  .iconBox:hover {
    background: #001121;
  }
}
.logoImg {
  position: absolute;
  right: 20px;
  top: 14px;
}
.avatar {
  width: 30px;
  height: 30px;
  vertical-align: middle;
  display: inline-block;
}
.username {
  // color: #fff;
  vertical-align: middle;
  font-size: 12px;
  margin-left: 4px;
}
.el-icon-arrow-down {
  color: #ccc;
}

html {
  background: #fff;
}
table {
  border-collapse: collapse;
  margin: 0 auto;
}
table td,
table th {
  // border: 1px solid #cad9ea;
  color: #666;
  height: 50px;
      padding-left: 26px;
}
table thead th {
  background-color: #cce8eb;
  width: 100px;
}
table tr:nth-child(even) {
  background: #fff;
}
table tr:nth-child(odd) {
  background: #f4f4f4;
}
.container {
  width: 100%;
  height: 100%;
  background: #fff;
  position: relative;
  top: 0;
}
.cont {
  width: 1300px;
  margin: 0 auto;
  font-size: 14px;
}
//头部导航
.header {
  display: flex;
  height: 60px;
  align-items: center;
  justify-content: space-between;
  .imgbox img {
    width: 130px;
    margin-top: 6px;
  }
  .nav {
    display: flex;
    margin-right: 60px;
    li {
      margin: 0 6px;
      cursor: pointer;
    }
    a {
      text-decoration: none;
    }
  }
}
//头部-图片
.img_main {
  width: 100%;
  height: 578px;
  img {
    width: 100%;
    height: 100%;
  }
}
//主体
.main {
  // position: absolute;
  background-color: #fff;
  position: relative;
  top: -60px;
  // top: 0;
  // bottom: 0;
  // left: 0;
  // right: 0;
  margin: 0 auto;
  .main_number {
    width: 100%;
    height: 160px;
    // line-height: 160px;
    background-color: #fff;
    display: flex;
    .number {
      flex: 1;
      text-align: center;
      padding-top: 40px;
      box-sizing: border-box;
    }
  }
  .fuwu_title {
    width: 201px;
    height: 80px;
    .h3 {
      height: 40px;
      line-height: 40px;
      font-weight: 700;
      font-size: 20px;
      border-bottom: 1px solid black;
    }
    .span {
      margin-top: 10px;
      width: 80px;
      height: 1px;
      background-color: #ccc;
    }
  }
  .main_fuWu {
    width: 100%;
    // height: 482px;
    margin-top: 80px;
    background-color: #fff;

    ul {
      display: flex;
      justify-content: space-between !important;
      li {
        // flex: 1;
        width: 29%;
        height: 392px;
        overflow: hidden;
        div {
          // width: 99%;
          height: 100%;
          box-sizing: border-box;
          .div {
            height: 60%;
            background-color: #2c2c2c;
            margin-bottom: 10px;
            img {
              height: 100%;
            }
          }
        }
        span {
          font-weight: 700;
          font-size: 16px;
        }
        p {
        }
      }
    }
  }
  .main_huoYuan {
    margin-top: 10px;
    width: 100%;
    height: 800px;
    .huoYuan {
      height: 700px;
      display: flex;
      .huoyuan_img {
        height: 100%;
        flex: 1;
        padding-right: 93px;
        img {
          height: 100%;
          width: 100%;
        }
      }
      .huoyuan_table {
        width: 64%;
      }
      .el-table {
        height: 46%;
      }
    }
  }
  .main_chanPing {
    margin-top: 80px;
    width: 100%;
    height: 800px;
    .chanping {
      height: 700px;
      display: flex;
    }
    .chanping_img {
      height: 100%;
      flex: 1;
      padding-left: 93px;
      background-image: url("../../../assets/website/手机.png") no-repeat !important;
      img {
        height: 100%;
        width: 100%;
      }
      .el-carousel__container {
        height: auto !important;
      }
      .el-carousel__item h3 {
        color: #475669;
        font-size: 18px;
        opacity: 0.75;
        line-height: 800px;
        margin: 0;
      }

      .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
      }

      .el-carousel__item:nth-child(2n + 1) {
        background-color: #d3dce6;
      }
    }
    .chanping_data {
      width: 64%;
      ul {
        height: 100%;
        display: flex;
        flex-direction: column;
        li {
          flex: 1;
          display: flex;
          margin-top: 6%;
          .span {
            width: 110px;
            height: 110px;
            border-radius: 20px;
            img {
              height: 100%;
            }
          }
          .div {
            width: 100%;
            margin-left: 40px;
            overflow: hidden;
            div {
              font-weight: 700;
              font-size: 18px;
            }
            p {
              // word-wrap: break-word;
              // word-break: normal;
            }
          }
        }
      }
    }
  }
  .main_women {
    margin-top: 80px;
    width: 100%;
    height: 800px;
    .women {
      height: 700px;
      display: flex;
      .women_img {
        flex: 1;
        padding-right: 93px;
      }
      .women_data {
        width: 64%;
        ul {
          display: flex;
          flex-direction: column;
          margin-top: 200px;
          li {
            flex: 1;
            margin-bottom: 40px;
            .div {
              width: 100%;
              margin-left: 40px;
              overflow: hidden;
              div {
                font-weight: 700;
                font-size: 18px;
              }
              p {
                // word-wrap: break-word;
                // word-break: normal;
              }
            }
          }
        }
      }
    }
  }
  .main_map {
    margin-top: 80px;
    width: 100%;
    height: 7 00px;
    .map_title {
      width: 100%;
      height: 120px;
      line-height: 120px;
      ul {
        width: 450px;
        height: 120px;
        display: flex;
        margin: 0 auto;

        li {
          flex: 1;
        }
      }
    }
    .map {
      width: 100%;
      height: 700px;
    }
    #map {
      width: 100%;
      height: 700px;
    }
  }
  .main_hezuo {
    margin-top: 80px;
    width: 100%;
    height: 300px;
    ul {
      display: flex;
      li {
        flex: 1;
        padding: 0 5px;
      }
    }
  }
}
.minfont{
  font-size: 12px;
}
.foot {
  width: 100%;
  background-color: #3d4449;
  // line-height: 240px;
  .foot_main {
    margin: 0 auto;
    display: flex;
    padding-top: 20px;
    color: #fff;
    align-items: center;
    img{
      width: 190px;
    }
    .data {
      width: 600px;
      ul {
        font-size: 14px;
        display: flex;
        height: 40px;
        li {
          flex: 1;
        }
      }
    }
    .com {
      flex: 1;
    }
    .number {
      p {
        font-size: 12px;
      }
    }
  }
}

/*订单总量滚动数字设置*/
.box-item {
  position: relative;
  height: 60px;
  font-size: 24px;
  line-height: 41px;
  text-align: center;
  list-style: none;
  color: #fff;
  writing-mode: vertical-lr;
  text-orientation: upright;
  /*文字禁止编辑*/
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
  /* overflow: hidden; */
}
/* 默认逗号设置 */
.mark-item {
  width: 10px;
  height: 100px;
  margin-right: 5px;
  line-height: 10px;
  font-size: 48px;
  position: relative;
  & > span {
    position: absolute;
    width: 100%;
    bottom: 0;
    writing-mode: vertical-rl;
    text-orientation: upright;
  }
}
/*滚动数字设置*/
.number-item {
  width: 28px;
  height: 45px;
  /* 背景图片 */
  background: url("../../../assets/website/201912890540036.png") no-repeat
    center center;
  background-size: 100% 100%;
  // background: #ccc;
  list-style: none;
  margin-right: 5px;
  // background:rgba(250,250,250,1);
  border-radius: 4px;
  border: 1px solid rgba(221, 221, 221, 1);
  & > span {
    position: relative;
    display: inline-block;
    margin-right: 10px;
    width: 100%;
    height: 100%;
    writing-mode: vertical-rl;
    text-orientation: upright;
    overflow: hidden;
    & > i {
      font-style: normal;
      position: absolute;
      top: 11px;
      left: 50%;
      transform: translate(-50%, 0);
      transition: transform 1s ease-in-out;
      letter-spacing: 10px;
    }
  }
}
.number-item:last-child {
  margin-right: 0;
}
.footer{
  width: 100%;
  color: #fff;
  background:  #2f3335;
  line-height: 40px;
  font-size: 12px;
  text-align: center;
}
.fa-lg{
  font-size: 12px;
  color: #0c46a2;
}
.icon{
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 50%;
  background: #0c46a2;
  font-size: 12px;
  color: #fff;
  margin-right: 4px;
  text-align: center;
}

@media screen and (max-width:1500px) {
  .cont {
    width: 990px;
  }
}
</style>
